<div class="chk-video-section section-gap">
  <div class="container">
    <div class="row" >
      <ng-container *ngIf="config.video.layout == 'right'">
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 wow fadeIn animated" data-wow-duration="2s" data-wow-delay="3s">
          <ng-container *ngTemplateOutlet="title"></ng-container>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 wow fadeIn animated" data-wow-duration="2s" data-wow-delay="3s">
          <ng-container *ngTemplateOutlet="video"></ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="config.video.layout == 'left'">
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 wow fadeIn animated" data-wow-duration="2s" data-wow-delay="3s">
          <ng-container *ngTemplateOutlet="title"></ng-container>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 video-holder wow fadeIn animated" data-wow-duration="2s" data-wow-delay="3s">
          <ng-container *ngTemplateOutlet="video"></ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="config.video.layout == 'full-width'">
        <div class="col-12 wow fadeIn animated" data-wow-duration="2s" data-wow-delay="3s">
          <ng-container *ngTemplateOutlet="title"></ng-container>
        </div>
        <div class="col-12 col-lg-8 offset-lg-2 wow fadeIn animated" data-wow-duration="2s" data-wow-delay="3s">
          <ng-container *ngTemplateOutlet="video"></ng-container>
        </div>
      </ng-container>

    </div>
  </div>
</div>


<ng-template #title>
  <div class="">
    <div class="section-title-wrapper mb-3">
      <app-badges [badges]="config.title.badges"></app-badges>
      <h2 class="mb-4">{{config?.title.title}}</h2>
      <p class="mb-0" [innerHtml]="config.title.description">
      </p>
    </div>
    <ul class="list-unstyled m-md-b">
      <li class="mb-2 font-weight-bold" *ngFor="let details of config?.title.list">
        <span class="mr-2 d-inline-block"><i class="fa fa fa-caret-right"></i></span>
        <span class="d-flex-inline align-top">{{details.title}}</span>
      </li>
    </ul>
  </div>
</ng-template>


<ng-template #video>
  <div class="video-content border-rad" *ngIf="config">
    <div class="embed-container border-radius" *ngIf="!config.youtubeVideo">
      <vg-player class="border-radius" [class.active]="classVideo" (click)="toggleVideoClass()">
        <vg-overlay-play></vg-overlay-play>
        <vg-buffering></vg-buffering>

        <vg-scrub-bar>
          <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
          <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
        </vg-scrub-bar>

        <vg-controls>
          <vg-play-pause></vg-play-pause>
          <vg-playback-button></vg-playback-button>

          <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

          <vg-scrub-bar style="pointer-events: none;"></vg-scrub-bar>

          <vg-time-display vgProperty="left" vgFormat="mm:ss"></vg-time-display>
          <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

          <vg-track-selector></vg-track-selector>
          <vg-mute></vg-mute>
          <vg-volume></vg-volume>

          <vg-fullscreen></vg-fullscreen>
        </vg-controls>

        <video #media [vgMedia]="media" id="singleVideo" preload="auto" crossorigin>
          <source *ngFor="let video of sources" [src]="video.src" [type]="video.type">
        </video>
      </vg-player>
    </div>

    <div class="youtube-container" *ngIf="config.youtubeVideo">
      <div class="embed-responsive embed-responsive-16by9">
        <iframe class="embed-responsive-item border-radius" [src]="youTubeLink | safeResourceUrl" frameborder="0"
                allow="autoplay; encrypted-media" allowfullscreen>
        </iframe>
      </div>
    </div>
  </div>
</ng-template>
